import { createClient } from 'graphql-ws';
import config from 'config';
import {
  currentCountryVar,
  currentShopIdVar,
  currentTokenVar,
} from './cache/auth';

const graphqlWsUrl = (httpUrl: string) => {
  const url = new URL(httpUrl);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return url.toString();
};

const connectedListeners = new Set<() => void>();

export const onGraphqlWsConnected = (cb: () => void) => {
  connectedListeners.add(cb);
  return () => {
    connectedListeners.delete(cb);
  };
};

export const graphqlWsClient = createClient({
  url: graphqlWsUrl(config.apollo.uri),
  lazy: true,
  retryAttempts: Infinity,
  shouldRetry: () => true,
  connectionParams: () => {
    const token = currentTokenVar();
    const country = currentCountryVar();
    const shopId = currentShopIdVar();

    return {
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      ...(country ? { country } : {}),
      ...(shopId ? { 'x-shop-id': shopId } : {}),
      source: 'supplier-console',
    };
  },
  on: {
    connected: () => {
      connectedListeners.forEach((cb) => cb());
    },
  },
});

/** Server builds WS context once on connect. Call after token or country changes. */
export const restartGraphqlWs = () => {
  graphqlWsClient.terminate();
};
